<template>
  <div class="inline-block">
    <!-- 转化事件 -->
    <div v-if="formKey === 'convert_id'">
      <div class="flex items-center">
        <el-button v-if="!formItem.isPreview" type="primary" size="mini" @click="onDataDialog('budget_and_bid_form', 'convert_id', '转化事件目标')">选择转化目标</el-button>
        <i v-if="formItem.value && !formItem.isPreview" class="el-icon-success app-check-icon-success ml-10" />
      </div>
    </div>
    <!-- 数据弹窗 -->
    <el-dialog
      v-if="data_dialog_config.is_show"
      :title="data_dialog_config.title"
      :visible.sync="data_dialog_config.is_show"
      append-to-body
      width="1200px"
    >
      <component
        :is="data_dialog_config.map_component_name[data_dialog_config.active_name]"
        v-if="data_dialog_config.is_show"
        v-loading="data_dialog_config.is_loading"
        v-bind="data_dialog_config.getters.getProps(data_dialog_config.active_name)"
        @confirm="onDataDialogConfirm"
        @cancel="onDataDialogCancel"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getConvertApi } from '@/api/tool/convert';
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'conversion-event': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/components/multiple-conversion'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  data() {
    return {
      // 数据弹窗配置
      data_dialog_config: {
        is_show: false,
        title: '',
        is_loading: false,
        active_name: '',
        map_component_name: {
          convert_id: 'conversion-event',
        },
        getters: {
          getProps: (active_name) => {
            const map_props = {
              convert_id: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
                channelCodesField: this.getChannelCodesField(),
              },
            };
            return Object.assign(map_props[active_name] || {});
          },
        },
      },
    };
  },
  methods: {
    /**
     * 打开数据弹窗
     * @param {string} field_key 表单配置项
     * @param {string} active_name 表单项
     * @param {string} title 弹窗标题
     */
    onDataDialog(field_key, active_name, title) {
      Object.assign(this.data_dialog_config, {
        is_show: true,
        is_loading: false,
        title,
        active_name,
        field_key,
      });
    },
    /**
     * 获取当前配置的渠道字段
     */
    getChannelCodesField() {
      const { delivery_form } = this.formFields.config;
      const { fusion__channel_code } = delivery_form.config;
      const { fusion__channel_codes } = fusion__channel_code.children;
      return fusion__channel_codes;
    },
    /**
     * 删除转化事件中conversion字段
     * @param data 转化事件数据
     */
    handleDeleteConversion(data) {
      (data.value || []).forEach(({ list = [] }) => {
        list.forEach((convert) => {
          delete convert?.conversion;
        });
      });
    },
    /**
     * 获取转化目标查询参数
     */
    getConvertFiltering() {
      const { delivery_form } = this.formFields.config;
      const { delivery_content_id: { value: { result_map }}, delivery_platform_type } = delivery_form.config;

      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const channel_interface = dataController.getChannelInterfaceEnum();
      const advertiser_id = dataController.getRequestAdvertiser();

      return {
        channel_interface,
        advertiser_id,
        page: 1,
        page_size: 10,
        filtering: {
          ...(Object.keys(result_map).length && { delivery_content_id: Object.values(result_map)[0].value.split('#')[0] }),
          delivery_platform_type: delivery_platform_type.value,
        },
      };
    },
    /**
     * 获取转化目标
     * @param {Object} params 查询参数
     */
    getConvertList(params) {
      return new Promise((resolve, reject) => {
        getConvertApi(params)
          .then((res) => {
            res.list.forEach((item) => {
              Object.assign(item, { template_data: JSON.stringify(item) });
            });
            resolve(res);
          })
          .catch(reject);
      });
    },
    /**
     * 获取优化目标
     * @param {Object} params 查询参数
     */
    getConvertGoalList(params) {
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      return new Promise((resolve, reject) => {
        dataController.getConvertGoalList(params).then(resolve).catch(reject);
      });
    },
    /**
     * 获取深度优化目标列表
     * @param {Object} params 查询参数
     */
    getDeepConvertGoalList(params) {
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      return new Promise((resolve, reject) => {
        dataController.getDeepConvertGoalList(params).then(resolve).catch(reject);
      });
    },
    /**
     * 数据模块确认回调
     * @param {Object} payload 确认数据
     */
    async onDataDialogConfirm(payload) {
      this.data_dialog_config.is_loading = true;
      const { field_key, active_name } = this.data_dialog_config;
      const handlers_map = {
        // 转化事件
        convert_id: async() => {
          const { delivery_form } = this.formFields.config;
          const { fusion__channel_code } = delivery_form.config;
          const { fusion__channel_codes } = fusion__channel_code.children;
          const { template_data, channels_codes } = payload;

          const { config } = this.formFields.config[field_key];
          config[active_name].value = template_data;
          Object.assign(fusion__channel_codes, channels_codes);
          const { fusion__optimize_goal, deep_convert_type } = config;

          /** 优化目标 */
          const { id: convert_id } = template_data ? JSON.parse(template_data) : {};
          fusion__optimize_goal.options = await this.getConvertGoalList({ baidu_params: { filtering: { convert_id }}});
          const is_match_optimize_goal = fusion__optimize_goal.options.some(({ value }) => fusion__optimize_goal.value === value);
          if (!is_match_optimize_goal) {
            fusion__optimize_goal.value = '';
            fusion__optimize_goal.backup_value = '';
            deep_convert_type.value = '';
            deep_convert_type.options = [];
          }

          /** 深度优化目标 */
          if (fusion__optimize_goal.value) {
            const deep_convert_type_options = await this.getDeepConvertGoalList({ baidu_params: { filtering: { convert_id, convert_goal: fusion__optimize_goal.value }}});
            deep_convert_type.options = deep_convert_type_options.filter(({ value }) => value !== fusion__optimize_goal.value);
            const is_match_deep_convert_type = deep_convert_type.options.some(({ value }) => deep_convert_type.value === value);
            !is_match_deep_convert_type && (deep_convert_type.value = '');
          }

          fusion__optimize_goal.on.change();

          this.onDataDialogCancel();
          this.$parent.$parent.$parent.validateField('convert_id.value');
        },
      };
      await handlers_map[active_name]?.();
      this.onDataDialogCancel();
    },

    async onDataDialogCancel() {
      Object.assign(this.data_dialog_config, { is_show: false, is_loading: false, title: '', active_name: '', field_key: '' });
    },
  },
};
</script>

<style lang="scss">
.step-form-wrapper {
  .smart-delivery-goal {
    display: none;
  }
}
</style>
